import { VALIDATE_RESET_TOKEN } from "../actions/types";

export default (response = null, action) => {
  if (action.type === VALIDATE_RESET_TOKEN) {
    return action.payload;
  }
  return response;
};
